@if (loading) {
  <loading class="tw-absolute tw-top-1/2 tw-left-1/2 tw-translate-x-[-50%] tw-translate-y-[-50%]"
  ></loading>
}
@if (isShopRevampExperimentOn && !loading) {
  <div class="tw-fixed tw-top-0 tw-left-0 tw-right-0 tw-px-6 tw-pt-6 tw-pb-4 tw-bg-white tw-shadow-z1 tw-z-10 tw-flex tw-items-center tw-justify-between">
    <div class="tw-h-10 tw-w-10 tw-flex tw-items-center tw-justify-center"
      (click)="back()">
      <cs-icon class="tw-h-6 tw-w-6 tw-text-black"
      [iconName]="'arrow_back'"></cs-icon>
    </div>
    <div class="tw-flex-1 tw-text-center tw-flex tw-items-center tw-justify-center tw-font-lexend tw-font-bold tw-text-300">
      {{ collectionTitle }}
    </div>
    <div class="tw-h-10 tw-w-10 tw-relative tw-flex tw-items-center tw-justify-center"
      (click)="goToCart()">
      <cs-icon class="tw-h-6 tw-w-6 tw-text-black"
      [iconName]="'shopping_cart'"></cs-icon><span
    class="tw-absolute -tw-top-1 tw-right-1 tw-font-body tw-font-bold tw-h-[14px] tw-text-200 tw-text-red-400">{{toolbarIcons[0]?.cartValue}}</span>
  </div>
</div>
}
@if(!isShopRevampExperimentOn && !loading)  {
  <div class="tw-fixed tw-left-6 tw-top-6 tw-z-10 tw-flex tw-items-center tw-justify-center tw-bg-black tw-rounded-xl tw-h-10 tw-w-10"
    (click)="back()">
    <cs-icon class="tw-h-6 tw-w-6 tw-text-white"
    [iconName]="'arrow_back'"></cs-icon>
  </div>
  <div class="tw-fixed tw-right-6 tw-top-6 tw-z-10 tw-flex tw-items-center tw-justify-center tw-bg-black tw-rounded-xl tw-h-10 tw-w-10"
    (click)="goToCart()">
    <cs-icon class="tw-h-6 tw-w-6 tw-text-white"
    [iconName]="'shopping_cart'"></cs-icon><span
  class="tw-absolute tw-top-[2px] tw-right-[18%] tw-bg-black tw-font-body tw-font-bold tw-h-[14px] tw-text-200 tw-text-red-400">{{toolbarIcons[0]?.cartValue}}</span>
</div>
}
@if (!loading) {
  <div class="tw-block tw-border-spacing-0 tw-overflow-hidden tw-w-full tw-h-full tw-font-body tw-relative"
    id="reorderRegimenPage"
    >
    <div class="tw-flex tw-flex-col tw-h-full">
      <div class="tw-overflow-y-scroll tw-pt-24">
        @if (!isShopRevampExperimentOn) {
          @if (!searchKey?.length) {
            <div class="tw-p-4 tw-relative tw-flex tw-flex-col tw-items-start tw-justify-end tw-w-[70%]"
              id="sectionTitle"
              style="padding-top: unset;"
              >
              @if (toolbarTitle === 'Recommended Products') {
                <div class="tw-text-[20px] tw-font-bold tw-float-left tw-text-[#242424]"
                  i18n="@@recommProductsForYou">
            Recommended products for you
          </div>
              }
              @if (toolbarTitle === 'Reorder Products') {
                <div class="tw-text-[20px] tw-font-bold tw-float-left tw-text-[#242424]"
                  i18n="@@reorderProducts">
            Reorder products
          </div>
              }
              @if (toolbarTitle === 'Select Products') {
                <div class="tw-text-[20px] tw-font-bold tw-float-left tw-text-[#242424]"
                  i18n="@@selectProducts">
            Select products
          </div>
              }
              @if (toolbarTitle === 'Sale Products') {
                <div class="tw-text-[20px] tw-font-bold tw-float-left tw-text-[#242424]"
                  >
                  {{saleVariants?.saleTitle}}
                </div>
              }
              @if (toolbarTitle === 'BOGO Sale Products') {
                <div class="tw-text-[20px] tw-font-bold tw-float-left tw-text-[#242424]"
                  >
                  {{personalizedBogoTitle?.saleTitle}}
                </div>
              }
            </div>
          }
        }
        @if (searchKey?.length) {
          <div class="tw-p-4 tw-relative tw-flex tw-items-start tw-justify-end tw-w-[70%]"
            style="padding-top: unset;"
            >
            <div class="tw-text-[20px] tw-font-bold tw-float-left tw-text-[#242424]">"{{searchKey}}"</div>
          </div>
        }
        @if (!loading && !productsAvailable.length) {
          <div class="tw-w-[85%] tw-pt-[75px] tw-px-5 tw-text-center tw-leading-[1.8rem] tw-font-normal tw-text-[1.1rem] tw-bg-no-repeat tw-bg-top tw-bg-60 tw-absolute tw-top-2/4 tw-left-2/4 tw-translate-x-[-50%] tw-translate-y-[-50%]"
            style="background-image: url('/assets/images/not-found.png'); background-size: 60px;"
            id="noAvailableProducts"
            i18n="@@noProductsAvailable">
        No products available
      </div>
        }
        <div class="tw-grid tw-grid-cols-2"
          [class]="isShopRevampExperimentOn ? 'tw-gap-y-8 tw-gap-x-6 tw-px-6 tw-font-lexend' : 'tw-gap-2 tw-px-4'"
          [ngClass]='{ "tw-pb-[100px]": aovTask }'>
          @for (item of productsAvailable; track item; let i = $index) {
            @if (item.price !== 0 && (item.productUnboxedImage?.length || item.rebrandedImageWithBackground?.length || item?.productImage)) {
              <div class="tw-animate-anim_fadeIn"
                style="box-shadow: unset;"
                (click)="viewProduct(item)">
                <div class="tw-flex tw-flex-col tw-justify-between tw-h-full" [class]="{'tw-items-center': !isShopRevampExperimentOn}"
                  [id]="item?.objectId">
                  <div [class]="isShopRevampExperimentOn ? 'tw-bg-gray-100 tw-aspect-[144/180] tw-rounded-t-3' : 'tw-rounded-t-[20px]'"
                    class="tw-overflow-hidden">
                    <img class="tw-object-contain"
                      [class]="isShopRevampExperimentOn ? 'tw-w-full tw-h-full' : 'tw-mb-[14px] tw-w-40 tw-h-50 tw-rounded-[20px]'"
                      alt="product"
                      #img=""
                      [src]='item?.productImage || (item?.rebrandedImageWithBackground && item?.rebrandedImageWithBackground.length ? item?.rebrandedImageWithBackground[item.rebrandedImageWithBackground.length - 1] : false || item?.productUnboxedImage[item.productUnboxedImage.length - 1] || item?.images[item.images.length - 1])' />
                  </div>
                  @if (isShopRevampExperimentOn) {
                    <div class="tw-text-300 tw-leading-[18px]" style="margin-bottom: unset;">
                      <div class="tw-text-300 tw-leading-[18px] tw-mt-2" id="productTitleRebranded">{{item.title}}</div>
                    </div>
                    <div class="tw-leading-[18px] tw-font-bold tw-mt-1 tw-mb-2">
                      <del class="tw-pr-1 tw-text-200 tw-text-gray-500">₹{{item?.mrp}}</del><span class="tw-text-300 tw-text-orange-500">₹{{item?.price}}</span>
                    </div>
                    @if (productsInCart[item.objectId]) {
                      <div class="tw-h-8 tw-border tw-border-teal-600 tw-rounded-2 tw-flex tw-w-fit tw-items-center tw-text-300 tw-bg-white tw-text-teal-600 tw-font-lexend tw-font-semibold swiper-no-swiping">
                        <div class="tw-px-[11.5px] tw-flex">
                          <cs-icon class="tw-w-[9px] tw-h-5 tw-text-teal-600" [iconName]="'minus'" (click)='addOrRemoveFromCart(i, "REMOVE", $event, img)'></cs-icon>
                        </div>
                        <span class="tw-px-1">{{ productsInCart[item.objectId] || 0 }}</span>
                        <div class="tw-px-[11.5px] tw-flex">
                          <cs-icon class="tw-w-[9px] tw-h-5 tw-text-teal-600" [iconName]="'plus'" (click)='addOrRemoveFromCart(i, "ADD", $event, img)'></cs-icon>
                        </div>
                      </div>
                    }
                    @if (!productsInCart[item.objectId]) {
                      <button csButton
                        size="small"
                        (click)='addOrRemoveFromCart(i, "ADD", $event, img)'
                        class="tw-min-w-fit tw-w-fit tw-px-[26px]"
                        style="margin: 0 !important;">
                        <span class="tw-text-300" i18n="@@add">Add</span>
                      </button>
                    }
                  } @else {
                    <div class="tw-m-5 tw-text-center tw-text-[14px] tw-mt-0"
                      style="margin-bottom: unset;">
                      <div class="tw-text-[12px] font12"
                      id="productTitle">{{item.title}}</div>
                    </div>
                    <div
                      class="tw-text-[1.2rem] tw-leading-[1.8rem] tw-tracking-[1px] tw-font-bold tw-text-center tw-mx-5 tw-mt-1 tw-mb-2">
                      <del class="tw-pr-1">₹{{item?.mrp}}</del><span class="tw-text-orange-500">₹{{item?.price}}</span>
                    </div>
                    @if (productsInCart[item.objectId]) {
                      <div class="tw-h-[36px] tw-max-w-36 tw-min-w-36 tw-border tw-border-teal-600 tw-rounded-3 tw-flex tw-justify-evenly tw-items-center tw-m-[10px] tw-text-300 tw-font-bold tw-font-body tw-bg-white tw-text-teal-600"
                        >
                        <em class="cs-icon-minus"
                        (click)='addOrRemoveFromCart(i, "REMOVE", $event, img)'></em>
                        <span>
                          {{ productsInCart[item.objectId] || 0 }}
                        </span>
                        <em class="cs-icon-plus"
                        (click)='addOrRemoveFromCart(i, "ADD", $event, img)'></em>
                      </div>
                    }
                    @if (!productsInCart[item.objectId]) {
                      <div class="tw-mx-[5px] tw-my-[10px] tw-rounded-[14px] "
                        (click)='addOrRemoveFromCart(i, "ADD", $event, img)'>
                        <div></div>
                        <div
                          class="tw-flex tw-items-center tw-py-[6px] tw-px-4 tw-gap-2 tw-text-white tw-font-bold tw-h-9 tw-bg-teal-600 tw-rounded-3">
                          <span i18n="@@addToCart">Add to Cart</span>
                          <em class="cs-icon-arrow tw-translate-y-[1px]"></em>
                        </div>
                      </div>
                    }
                  }
                </div>
              </div>
            }
          }
        </div>
      </div>
      @if (aovTask && isAOVActive && !loading && !newCartUI) {
        <aov-sale class="tw-w-full"
          [numberOfProductsInCart]="toolbarIcons[0].cartValue"
          [maxPrice]="maxPrice"
          [showConfettiAnimation]="showConfettiAnimation"
          [barStyle]="barStyle"
          [cart]="cart"
          [prodImage]="prodImage"
          [amountRemaining]="amountRemaining"
          [fromListingPage]="true"
          [bottomBar]="totalSP && !loading"
        (onCheckout)="checkoutAOV()"></aov-sale>
      }
      @if (aovTask && isAOVActive && !loading && newCartUI) {
        <div class="tw-absolute tw-w-full"
          [ngClass]='{ "tw-h-32 tw-bottom-8": totalSP && !loading, "tw-h-16 tw-bottom-2": !(totalSP && !loading) }'>
          <app-aov-banner [amountRemaining]="amountRemaining"
            [freeProductBannerImage]="prodImage"
            [percentageDone]="toolbarIcons[0].cartValue ? percentageDone : 0"
            [isEnglishLanguage]="user?.get('languagePreference') === appConfig.Shared.Languages.EN"
          [displayWhenAmountRemainingIsZero]=true></app-aov-banner>
        </div>
      }
      @if (totalSP && toolbarIcons[0].cartValue) {
        <div class="tw-relative tw-shadow-[0_-1px_7px_rgba(0,0,0,0.13)] tw-w-full tw-flex-[0_1_0px] tw-mt-auto"
          >
          @if (+discount >= 5 && !aovTask) {
            <div class="tw-flex tw-item-center tw-justify-center tw-py-2 tw-bg-yellow-100"
              >
              <p class="tw-font-body tw-text-200 tw-text-black tw-flex tw-items-center tw-gap-1">
                <cs-icon class="tw-h-5 tw-w-5 tw-text-green-400"
                [iconName]="'sale'"></cs-icon><span i18n="@@discountAppliedForProducts">
            {{discount}}% discount applied</span>
            </p>
          </div>
        }
        <div class="tw-flex tw-items-center tw-p-5 tw-pl-3">
          <div class="tw-flex tw-items-center tw-mr-1">
            <cs-icon class="tw-h-6 tw-w-6 tw-text-gray-500"
            [iconName]="'shopping_cart'"></cs-icon>
            @if (+toolbarIcons[0].cartValue === 1) {
              <p class="tw-font-body tw-text-gray-500 tw-text-200"
                i18n="@@singleProduct">
            1 product -
          </p>
            }
            @if (+toolbarIcons[0].cartValue !== 1) {
              <p class="tw-font-body tw-text-gray-500 tw-text-200"
                i18n="@@multipleProducts">
            {{ toolbarIcons[0].cartValue }} products -
          </p>
            }
          </div>
          <div class="tw-flex-none tw-mr-4">
            <span class="tw-font-body tw-font-bold tw-text-500 tw-text-teal-600 tw-bg-white">
              ₹{{totalSP%1 != 0 ? totalSP.toFixed(2) : totalSP}}
            </span>
          </div>
          <div class="tw-flex-auto">
            <button class="tw-h-[49px] tw-w-full tw-gap-2 tw-items-center tw-leading-none shine-button tw-rounded-3 tw-bg-teal-600 tw-text-white"
              (click)="checkout()">
              <cs-button-text class="tw-font-body tw-font-bold tw-text-300"
              i18n="@@buyNow">Buy Now</cs-button-text>
              <cs-icon class="tw-h-7 tw-w-7 tw-text-white"
              [iconName]="'chevron_right'"></cs-icon>
            </button>
          </div>
        </div>
      </div>
    }
    <pop-up [show]="selfReorderWarning"
      (close)="closeDialog()"><self-reorder-warning (close)="back()"></self-reorder-warning></pop-up>
      @if (isDiscontinued) {
        <pop-up
          [class]="'bdr-rad-10 p15 popup-ht-unset'"
          [show]="isDiscontinued"
          [triggerDismiss]="true"
          (close)="closePopup()">
          <discontinued-popup [oldProductData]="oldProduct"
            [newProductData]="newProduct"
            (changeProduct)="changeProduct()"
          (articleOpen)="openArticle()"></discontinued-popup>
        </pop-up>
      }
      @if (animationProduct) {
        <div class="tw-absolute tw-p-5 tw-border tw-border-gray-500 tw-bg-white tw-flex tw-gap-4 animate-fly_product"
          style="height: 200px; top: calc(50% - 100px); right: 16px; left: 16px">
          <img class="tw-flex-none tw-w-auto tw-object-contain"
            alt="product"
            style="height: 158px"
            [src]='animationProduct?.rebrandedImageWithBackground && animationProduct?.rebrandedImageWithBackground.length ? animationProduct.rebrandedImageWithBackground[animationProduct.rebrandedImageWithBackground.length - 1] : false || animationProduct.productUnboxedImage[animationProduct.productUnboxedImage.length - 1] || animationProduct.images[animationProduct.images.length - 1]' />
          <div class="tw-flex-1 tw-text-[12px]">{{animationProduct.title}}</div>
        </div>
      }
    </div>
  </div>
}
